import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ActivityHeatmapEmbed } from '../components/ActivityHeatmapEmbed';
import { activityHeatmapCalendar } from '../config/openSource';
import { normalizeI18nLang } from '../utils/lang';
import './ActivityHeatmapCalendarPage.css';

function heatmapLocale(lang: string): string {
  const code = normalizeI18nLang(lang);
  if (code === 'zh') return 'zh-Hant';
  if (code === 'ja') return 'ja';
  return 'en';
}

const ActivityHeatmapCalendarPage: React.FC = () => {
  const { t, i18n } = useTranslation();
  const i18nBase = `openSource.packages.${activityHeatmapCalendar.i18nKey}`;

  return (
    <div className="oss-demo-page">
      <section className="page-header">
        <div className="container">
          <p className="oss-demo-kicker">{t('openSource.title')}</p>
          <h1 className="page-title">{t(`${i18nBase}.name`)}</h1>
          <p className="page-subtitle">{t(`${i18nBase}.subtitle`)}</p>
        </div>
      </section>

      <section className="oss-demo-content">
        <div className="container">
          <ActivityHeatmapEmbed
            className="oss-demo-embed"
            assetBase="/open-source/activity-heatmap-calendar/"
            feature="playground"
            locale={heatmapLocale(i18n.language)}
            height={680}
          />

          <div className="oss-demo-actions">
            <Link to="/open-source" className="btn btn-secondary btn-large">
              {t('openSource.demo.back')}
            </Link>
            <a
              href={activityHeatmapCalendar.githubUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary btn-large"
            >
              {t('openSource.viewOnGitHub')}
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ActivityHeatmapCalendarPage;
